import { createSelector } from 'reselect';

import { getActiveComponentDesign } from './getActiveComponentDesignSelector';

export const getActiveComponent = createSelector(
  getActiveComponentDesign,
  (componentDesign) => componentDesign?.component,
);
